import { createRouter, createWebHistory } from 'vue-router';

import { frontendURL } from '../helper/URLHelper';
import dashboard from './dashboard/dashboard.routes';
import store from 'dashboard/store';
import { validateLoggedInRoutes } from '../helper/routeHelpers';
import AnalyticsHelper from '../helper/AnalyticsHelper';

const routes = [...dashboard.routes];

export const router = createRouter({ history: createWebHistory(), routes });

// 지연 로딩한 화면 파일을 못 받으면(배포 뒤 옛 파일 이름, 순간 네트워크 오류) 빈 화면에 남는다.
// 같은 주소로 한 번만 새로 불러오고, 다시 실패하면 반복하지 않는다(무한 새로고침 방지).
const CHUNK_RELOAD_KEY = 'ddukdoc.chunkReloadPath';
export const isChunkLoadError = error =>
  /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Loading chunk [\w-]+ failed|ChunkLoadError/i.test(
    String(error?.message || error?.name || '')
  );

export const reloadOnChunkLoadError = (error, to) => {
  if (!isChunkLoadError(error)) return;
  const target = to?.fullPath || window.location.pathname;
  try {
    if (window.sessionStorage.getItem(CHUNK_RELOAD_KEY) === target) return;
    window.sessionStorage.setItem(CHUNK_RELOAD_KEY, target);
  } catch {
    // 저장소를 못 쓰면 반복 방지를 보장할 수 없어 새로고침하지 않는다.
    return;
  }
  window.location.assign(target);
};

router.onError(reloadOnChunkLoadError);

router.afterEach(() => {
  try {
    window.sessionStorage.removeItem(CHUNK_RELOAD_KEY);
  } catch {
    // 무시
  }
});

export const validateAuthenticateRoutePermission = (to, next) => {
  const { isLoggedIn, getCurrentUser: user } = store.getters;

  if (!isLoggedIn) {
    window.location.assign('/app/login');
    return '';
  }

  const { accounts = [], account_id: accountId } = user;

  if (user.password_change_required) {
    return to.name === 'required_password_change'
      ? next()
      : next({ name: 'required_password_change' });
  }

  if (to.name === 'required_password_change') {
    return next(
      frontendURL(
        accounts.length ? `accounts/${accountId}/dashboard` : 'no-accounts'
      )
    );
  }

  if (!accounts.length) {
    if (to.name === 'no_accounts') {
      return next();
    }
    return next(frontendURL('no-accounts'));
  }

  if (to.name === 'no_accounts' || !to.name) {
    return next(frontendURL(`accounts/${accountId}/dashboard`));
  }

  const nextRoute = validateLoggedInRoutes(to, store.getters.getCurrentUser);
  return nextRoute ? next(frontendURL(nextRoute)) : next();
};

export const initalizeRouter = () => {
  const userAuthentication = store.dispatch('setUser');

  router.beforeEach((to, _from, next) => {
    AnalyticsHelper.page(to.name || '', {
      path: to.path,
      name: to.name,
    });

    userAuthentication.then(() => {
      return validateAuthenticateRoutePermission(to, next, store);
    });
  });
};

export default router;
